import { c as o } from "./createLucideIcon-OVU-vHz1.js";
/**
 * @license lucide-react v0.562.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const c = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], n = o("chevron-up", c);
export {
  n as C
};
